var ExtendPropertyAdapter = /** @class */ (function () {
    function ExtendPropertyAdapter(data) {
        this._borderColor = data.borderColor;
        this._backgroundColor = data.backgroundColor;
        this._barColor = data.barColor;
        this._useAlarmLimit = data.useAlarmLimit;
        this._alarmLimit = {
            upperLimit: data.upperLimit,
            lowerLimit: data.lowerLimit,
            upperLimitColor: data.upperLimitColor,
            lowerLimitColor: data.lowerLimitColor
        };
    }
    Object.defineProperty(ExtendPropertyAdapter.prototype, "borderColor", {
        get: function () {
            return this._borderColor;
        },
        set: function (v) {
            this._borderColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyAdapter.prototype, "backgroundColor", {
        get: function () {
            return this._backgroundColor;
        },
        set: function (v) {
            this._backgroundColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyAdapter.prototype, "barColor", {
        get: function () {
            return this._barColor;
        },
        set: function (v) {
            this._barColor = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyAdapter.prototype, "useAlarmLimit", {
        get: function () {
            return this._useAlarmLimit;
        },
        set: function (v) {
            this._useAlarmLimit = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExtendPropertyAdapter.prototype, "alarmLimit", {
        get: function () {
            return this._alarmLimit;
        },
        set: function (v) {
            this._alarmLimit = v;
        },
        enumerable: true,
        configurable: true
    });
    return ExtendPropertyAdapter;
}());
export { ExtendPropertyAdapter };
